import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "form"]
  private timeout: number | null = null

  declare readonly inputTarget: HTMLInputElement
  declare readonly formTarget: HTMLFormElement

  search() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    this.timeout = window.setTimeout(() => {
      this.submit()
    }, 300)
  }

  private submit() {
    this.formTarget.requestSubmit()
  }
}
